import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

export default class extends Controller {
  static targets = ["illustration", "qrCode", "buttonText"]
  static values = { url: String }

  connect() {
    this.isShowingQR = false
    this.qrGenerated = false
    console.log("QR Toggle controller connected", this.urlValue)
  }

  toggle(event) {
    event.preventDefault()
    console.log("Toggle clicked, isShowingQR:", this.isShowingQR)

    if (this.isShowingQR) {
      // Show illustration, hide QR
      this.illustrationTarget.classList.remove("hidden")
      this.qrCodeTarget.classList.add("hidden")
      this.buttonTextTarget.textContent = "Show QR Code"
      this.isShowingQR = false
    } else {
      // Hide illustration, show QR
      this.illustrationTarget.classList.add("hidden")
      this.qrCodeTarget.classList.remove("hidden")
      this.buttonTextTarget.textContent = "Hide QR Code"
      this.isShowingQR = true

      // Generate QR code if not already generated
      if (!this.qrGenerated) {
        this.generateQRCode()
      }
    }
  }

  generateQRCode() {
    const container = this.qrCodeTarget.querySelector(".qr-code-container")
    console.log("Generating QR code for:", this.urlValue, "Container:", container)

    if (!container) {
      console.error("QR code container not found")
      return
    }

    if (!this.urlValue) {
      console.error("URL value not provided")
      return
    }

    QRCode.toCanvas(this.urlValue, {
      width: 200,
      margin: 1,
      color: {
        dark: "#000000",
        light: "#FFFFFF"
      }
    }, (error, canvas) => {
      if (error) {
        console.error("Error generating QR code:", error)
        return
      }

      console.log("QR code generated successfully")
      // Clear container and add canvas
      container.innerHTML = ""
      container.appendChild(canvas)
      this.qrGenerated = true
    })
  }
}
